export const scrollLock = () => {
  if (!document) return

  setTimeout(() => {
    const rootElement = document.documentElement

    const scrollTopOffset = rootElement.scrollTop

    rootElement.dataset.scrollTopOffset = String(scrollTopOffset)

    rootElement.style.top = `-${scrollTopOffset}px`

    rootElement.classList.add('ui-scroll-locked')
  }, 100)
}

export const scrollUnlock = () => {
  if (!window || !document) return

  setTimeout(() => {
    const rootElement = document.documentElement

    rootElement.style.top = ''

    rootElement.classList.remove('ui-scroll-locked')

    window.scrollTo(0, Number(rootElement.dataset.scrollTopOffset))

    rootElement.dataset.scrollTopOffset = ''
  }, 100)
}
